// apiService.js
import axios from 'axios';
import { getToken } from './authService';

// const BASE_URL = 'https://dev-backend.kind1technology.com/api'; // Your API base URL
// const BASE_URL = 'http://kind1technology.com/api'; // Your API base URL
// const BASE_URL = 'http://54.193.21.190/api/'; // Your API base URL
const BASE_URL = 'https://iconnctapp.com/api/'; // Your API base URL Live Server

const apiService = axios.create({
    baseURL: BASE_URL,
    // headers: {
    //   'Content-Type': 'application/json',
    // },
});

apiService.interceptors.request.use(
    (config) => {
        const token = getToken();
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiService;
